<template>
  <v-flex>
      <div ref="content">
      <v-card v-if="!justPlot">
          <v-hover>
          <v-card-text slot-scope="{ hover }" class="caption grey--text">
              <v-layout style="min-height:40px;">
                  <loading-progress-bar :loading="loading" color="secondary"></loading-progress-bar>
                  <v-spacer></v-spacer>
                  <v-fade-transition>
                  <span v-show="(!loading && hover)" ma-0 pa-0>
                      <v-btn @click="downloadWithCSS" outline small flat round class="grey--text" ma-0 pa-0>
                          Export as PDF
                      </v-btn>
                  </span>
                  </v-fade-transition>
                  <span>{{facility_name}} </span>
              </v-layout>
          </v-card-text>
          </v-hover>
          <v-card-text>
              <vue-plotly v-if="!loading&&data" :data="data" :disable-responsive="disableResponsive" :layout="layout" :options="options" ref="plotly"/>
          </v-card-text>
      </v-card>
          <vue-plotly v-if="justPlot&&!loading&&data" show-export :data="data" :disable-responsive="disableResponsive" :layout="layout" :options="options" ref="plotly"/>
      </div>
  </v-flex>
</template>

<script>
import VuePlotly from './VuePlotly'
import {callAPI} from '@/helper'
import LoadingProgressBar from './LoadingProgressBar'
import jsPDF from 'jspdf'
import {exportCSVFromDicts} from "@/tocsv.js"

export default {
  props: {
      layoutOverrides: {type: Object, default: null},
      dateRange: {type: Object, default: null},
      seriesOverrides: {type: Object, default: null},
      xAxis: {type: String, default: 'timestamp'},
      dataPayload: {type: Object, default: null},
      justPlot: {type: Boolean, default: false},
      onOnly: {type:Boolean, default: false},
      disableResponsive: {type: Boolean, default: false}
  },
  components: {
    LoadingProgressBar,
    VuePlotly
  },
  computed: {
    layout(){
        let settings={
            hovermode: 'closest',
        };
        if(this.layoutOverrides){
            settings=Object.assign({}, settings, this.layoutOverrides);
        }
      return settings;
    }
  },
  name: 'Data2Chart',
  watch: {
    dataPayload () {
      this.refresh()
    },
      dateRange () {
      this.refresh()
    },
      onOnly () {
          this.refresh()
      }
  },
  data: function () {
    return {
      data:[],
      timeout:null,
      facility_name:null,
      options: {},
      df: null,
      loading: true
    }
    },
  methods: {
    downloadCSV () {
      exportCSVFromDicts(this.df)
    },
    download() {
      const doc = new jsPDF();
      const contentHtml = this.$refs.content.innerHTML;

      doc.fromHTML(contentHtml, 15, 15, {
        width: 170
      });
      doc.save("export.pdf");
    },
     async downloadWithCSS() {
       //const doc = new jsPDF();
       var doc = new jsPDF('', 'pt', 'a4');

       /** WITH CSS */
       let img = null
       if(this.type==='dygraph'){
         img = this.$refs.dygraphplot.toImage()
         doc.addImage(img, 'JPEG', 0, 0,
           1.0*595.28,
           1.0*595.28/this.$refs.dygraphplot.$refs.graphdiv.clientWidth*this.$refs.dygraphplot.$refs.graphdiv.clientHeight)
       } else {
         img =  await this.$refs.plotly.toImage()
         doc.addImage(img, 'JPEG', 0, 0,
           1.0*595.28,
           1.0*592.28/this.$refs.plotly.$refs.container.clientWidth*this.$refs.plotly.$refs.container.clientHeight
         )
       }

        doc.save("export.pdf")

     },
      debounce(callback, wait) {
          clearTimeout(this.timeout);
          this.timeout= setTimeout(() => callback(), wait);
      },
      refresh(){
          this.debounce(this.doRefresh,200);
      },
      doRefresh() {
          let me = this;
          this.loading = true
          if (this.dataPayload) {
              this.data = []
              let payload=JSON.parse(JSON.stringify(this.dataPayload))
              if(payload.filters){
                  if(this.dateRange){
                      payload.filters.date_range=[this.dateRange.start,this.dateRange.end]
                  }
                  if(!payload.filters.facility_name&&this.facility_name){
                      payload.filters.facility_name=this.facility_name
                  }
                  if(this.onOnly){
                      payload.filters.on_only=this.onOnly
                  }
              }
              callAPI('data2/',payload).then(function(result){
                  me.df=result.data
                  let newData=[]
                  for (let seriesIndex in result.data){
                      if(seriesIndex===me.xAxis){
                          continue
                      }
                      let newSeries={
                          x:result.data[me.xAxis],
                          y:result.data[seriesIndex],
                          name:seriesIndex
                      }
                      if (me.seriesOverrides){
                          newSeries=Object.assign({}, newSeries, me.seriesOverrides)
                      }
                      newData.push(newSeries)
                  }
                  me.data = newData
                  me.loading = false
              })

          } else {
              this.loading = false
          }

    }
  },
   mounted () {
      this.facility_name = this.$store.state.pointsListStore.pointsList.facility_name
      this.refresh()
  }
}

</script>

<style scoped>

</style>
